import { Event } from "../../../../../Global/Base/Events";
import { IMultiActionToolbarButton } from "./IToolbarButton";
import { DesktopToolbarButton } from "./ToolbarButton";
/**Reprezentuje tlačítko pro MultiAction v toolbaru*/
export class MultiActionToolbarButton extends DesktopToolbarButton implements IMultiActionToolbarButton {
    //#region Fields
    public enabledVisualChanged: Event<MultiActionToolbarButton, boolean> = new Event<MultiActionToolbarButton, boolean>();
    //#endregion Fields

    //#region Properties
    public get isMultiSelect(): boolean {
        return true;
    }

    public override set enabledVisual(value: boolean) {
        super.enabledVisual = value;
        if (this.enabledVisualChanged)
            this.enabledVisualChanged.trigger(this, value);
    }

    public override get enabledVisual(): boolean {
        return this._enabledVisual;
    }
    //#endregion Properties

    //#region Methods
    protected override _addActionListeners(): void {
        // Prázdná metoda
    }
    protected override _removeActionListeners(): void {
        // Prázdná metoda
    }
    //#endregion Methods
}
